'use client';

import { useJobMutations } from '@/modules/job/contracts';

import { Result } from '@packages/domain-driven';

export const useRemoveJob = () => {
	const { removeJobMutation } = useJobMutations();

	const submit = async (jobId: string) => {
		try {
			await removeJobMutation.mutateAsync({ params: { jobId } });

			return Result.ok(true);
		}
		catch {
			return Result.fail('Unable to remove job');
		}
	};

	return {
		submit,
		...removeJobMutation,
	};
};
